<template>
  <layout-vertical>

    <!-- 常駐的帳號到期提醒（頁面內容上方，切換頁面時不會消失） -->
    <template #breadcrumb>
      <account-expiry-banner />
      <app-breadcrumb />
    </template>

    <router-view />

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import AccountExpiryBanner from '@/layouts/components/AccountExpiryBanner.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
    AppBreadcrumb,
    AccountExpiryBanner,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
